if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"status_paldesk","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(3(142|288|475|561)|6(009|3|540|592|658)|1668|1737|2139|714|787|9622)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}